import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as actions from "../../actions";
import * as Template from "../../templates";
import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = "businesses";

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);

  const dispatch = useDispatch();

  const params = useParams()
  const navigate = useNavigate()
  const [id, setId] = useState();

  const [name, setName] = useState(``);
  const [tell, setTell] = useState(``);
  const [website, setWebsite] = useState(``);
  const [sheba, setSheba] = useState(``);
  const [address, setAddress] = useState(``);
  const [zipcode, setZipcode] = useState(``);
  const [sheba_owner, setShebaOwner] = useState(``);
  const [logo, setLogo] = useState(``);
  const [state, setState] = useState(``);
  const [submitted, setSubmitted] = useState(false);

  const handleChangeState = (value) => setState(value);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.businesses_store != undefined && appReducer.businesses_store.error == false) ||
        (appReducer.businesses_update != undefined && appReducer.businesses_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.businesses_store,
    appReducer.businesses_update
  ])

  useEffect(() => {
    if (appReducer.businesses_edit != undefined && id != undefined) {
      let row = appReducer.businesses_edit.data;
      if (row) {
        setName(row.name);
        setTell(row.tell);
        setAddress(row.address)
        setZipcode(row.zipcode)
        setWebsite(row.website);
        setSheba(row.sheba);
        setShebaOwner(row.sheba_owner);
        setLogo(row.logo_full);
        setState({
          value: row.state,
          label: row.state == `active` ? `فعال` : `غیرفعال`,
        });
      }
    }
  }, [appReducer.businesses_edit]);


  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  return (
    <Template.Form hasGrid={true}>

        <Template.Input required label="نام" value={name} name="name" type="text" />

        <Template.Input
          label="وب‌ سایت"
          value={website}
          required
          className="ltr"
          name="website"
          type="text"
        />
        <Template.Input required className="ltr" label="تلفن" value={tell} name="tell" type="text" />
        <Template.Input
          label="شماره حساب"
          value={sheba}
          className="ltr"
          name="sheba"
          type="text"
        />
        <Template.Input
          value={sheba_owner}
          label="صاحب - صاحبان حساب"
          name="sheba_owner"
          type="text"
        />
        <Template.Input
          value={address}
          label="آدرس"
          name="address"
          type="text"
        />
        <Template.Input
          value={zipcode}
          label="کدپستی"
          className="ltr"
          name="zipcode"
          type="text"
        />
        <Template.FileInput
          deleteUrl="businesses/destroy_image"
          name="logo"
          rowId={id}
          value={logo && [logo]}
          label="لوگو"
        />
        <Template.SingleSelect
          withLabel
          required
          placeholder="وضعیت"
          onChange={handleChangeState}
          name="state"
          value={state}
          options={[
            {
              value: "active",
              label: "فعال",
            },
            {
              value: "deactive",
              label: "غیرفعال",
            },
          ]}
        />

 
      <Template.Button
        label="ذخیره"

        onClick={handleClick}
      />
    </Template.Form>
  )
};
